<template>
  <div class="nav-container">
    <ul class="claims-nav">
      <li v-for="(link, idx) in navlinks" :key="idx" :class="link.dropdown ? 'claims-dropdown' : ''">
        <a class="dropdown-title" :class="{ 'dropdown-active': showClaimMenu }" v-if="link.dropdown" @click="openMenu()" :style="{color: showClaimMenu ? '#E10A0A' : '#000000'}">{{link.text}}</a>
        <ul class="nav-dropdown" v-if="link.dropdown && showClaimMenu">
          <div class="nav-wrap">
            <li v-for="(sublink, idx) in link.dropdown" :key="idx"><router-link :to="sublink.url">{{ sublink.text }}</router-link></li>     
          </div>                                 
        </ul>
        <router-link v-if="!link.dropdown" :to="link.url">{{ link.text }}</router-link>
      </li>
    </ul>
    <ul class="help-nav">
      <li v-for="(link, idx) in helpLinks" :key="idx">
        <router-link :to="link.url">{{ link.text }}</router-link>
      </li>
    </ul>
    <div class="sign-in-wrapper">
      <router-link :to="!isLoggedIn ? '/login' : '/logout'" class="link-button login-link">
        <span class="button-svg-wrapper">
          <svg>
            <use xmlns:xlink="http://www.w3.org/1999/xlink" :xlink:href="require(`../assets/theme/${getReseller.id}/images/rebrand_ui.svg`) + '#profile'"></use>
          </svg>
        </span>
        {{ !isLoggedIn ? 'Sign In' : 'Sign Out' }}
      </router-link>      
    </div>
    
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { parseJwt } from '../util/parseJwt'
export default {
  name: 'topNav',
  data: () => ({
    showClaimMenu: false
  }),
  methods: {
    openMenu() {
      this.showClaimMenu = !this.showClaimMenu
    }
  },
  computed: {
    navlinks() {
      var links = this.getReseller.navlinks;
      // console.log(links)
      var claimsDropdown = {};
      var standalone = process.env.VUE_APP_FORM_TYPE == 'standalone';
      var resumeLink = standalone ? { text: "Resume a claim", url: "/myclaims/inprogress" } : { text: "Resume a claim", url: "/makeaclaim/resume" };
      // console.log(resumeLink)
      if(this.getReseller.navDropdown && this.getReseller.navDropdown.dropdown.length) {
        claimsDropdown = this.getReseller.navDropdown;
        claimsDropdown.dropdown.push(resumeLink);
        
        var dropdownObj = { text: 'My Claims', dropdown: claimsDropdown.dropdown};        
        links.splice((claimsDropdown.position-1), 0, dropdownObj);
      } else {
        links.splice(2,0,resumeLink);
      }      
      // console.log(links)
      return links;
    },
    helpLinks() {
      var hl = this.getReseller.navLinks2;
      var al = [
        { "text": "Change Password", "url": "/changepassword" }
      ]
      if(this.isLoggedIn) {
        hl = [...hl, ...al];
      }
      return hl;
    },
    isLoggedIn () {
      if(this.$store.state.authentication.status) {
        return this.$store.state.authentication.status.loggedIn 
      } else {
        return false;
      }     
    },
    username () {
      if(this.$store.state.authentication.user.token) {
        return parseJwt(this.$store.state.authentication.user.token)['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name']
      } else {
        return '';
      }      
    },
    ...mapGetters({
      getReseller: 'reseller/getResellerInfo'
    })
  }
}
</script>